import React, { Fragment, useCallback } from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { Flex, Box, Heading, Icon, Text, Button } from 'roo-ui/components';
import TextButton from 'components/TextButton';
import { getIsAuthenticated, getFirstName } from 'store/user/userSelectors';
import { getQffAuth } from 'lib/qffAuth';
import { useDataLayer } from 'hooks/useDataLayer';

const login = async () => {
  try {
    const qffAuth = await getQffAuth();
    qffAuth.showLoginModal();
  } catch (e) {
    //do nothing yet
  }
};

const logout = async () => {
  try {
    const qffAuth = await getQffAuth();
    qffAuth.logout();
  } catch (e) {
    //do nothing yet
  }
};

const NonUppercaseButton = styled(Button)`
  text-transform: none;
  font-weight: normal;
  letter-spacing: normal;
`;

const LoginMessaging = () => {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const firstName = useSelector(getFirstName);
  const { emitInteractionEvent } = useDataLayer();
  const handleOnClick = useCallback(() => {
    login();
    emitInteractionEvent({ type: 'Frequent Flyer Login', value: 'Top Banner Selected' });
  }, [emitInteractionEvent]);

  return isAuthenticated ? (
    <Flex px={[4, 8]} py={4} mb={8} borderBottom={1} borderColor="greys.alto" bg="white">
      <Box mr={[3, 5]}>
        <Icon name="checkCircle" color="green" size={32} />
      </Box>
      <Flex justifyContent="space-between" flex="1 1 auto">
        <Heading.h2 fontWeight="bold" fontSize="md" mb={0} lineHeight="32px" data-testid="welcome-message">
          Welcome {firstName}.
        </Heading.h2>
        <Box>
          <TextButton onClick={logout} lineHeight="2" textDecoration="none" fontWeight="bold" data-testid="logout-button">
            LOG OUT
          </TextButton>
        </Box>
      </Flex>
    </Flex>
  ) : (
    <Fragment>
      <Box display={['none', 'block']} data-testid="hide-from-phone">
        <Flex px={[4, 8]} py={4} mb={8} bg="brand.primary" justifyContent="space-between" flex="1 1 auto" borderRadius="default">
          <Text fontSize="base" color="white" mb={0} lineHeight="32px" data-testid="call-to-action">
            Earn & use your Qantas Points and enjoy a faster booking experience
          </Text>
          <Flex>
            <TextButton
              onClick={handleOnClick}
              textDecoration="none"
              fontWeight="bold"
              color="white"
              hoverColor="white"
              data-testid="login-button"
            >
              LOGIN
              <Icon name="chevronRight" pb="2px" />
            </TextButton>
          </Flex>
        </Flex>
      </Box>
      <NonUppercaseButton
        onClick={handleOnClick}
        data-testid="login-button-phone"
        display={['block', 'none']}
        bg="brand.primary"
        p={4}
        mb={8}
        width="100%"
      >
        Login to use your Qantas Points <Icon name="chevronRight" />
      </NonUppercaseButton>
    </Fragment>
  );
};

export default LoginMessaging;
